import {Component, Injector} from '@angular/core';
import {Loader} from '../loader.abstract';

@Component({
    selector: 'clients-circle-loader',
    templateUrl: './circle-loader.component.html',
    styleUrls: ['./circle-loader.component.scss']
})
export class CircleLoaderComponent extends Loader {
    constructor(injector: Injector) {
        super(injector);
    }
}
